<template>
    <div class="l-ss-c-offer-image-wrapper">
        <div
            v-if="!loaded && !isCached"
            class="l-ss-c-offer-image-placeholder"></div>
        <img
            :src="src"
            :alt="alt"
            loading="lazy"
            @load="onLoad"
            @error="onError"
            class="l-ss-c-offer-image"
            :class="{ 'l-ss-c-offer-image-loaded': loaded }"
            :style="imgStyle">
    </div>
</template>

<script>
    export default {
        name: 'offer-lazy-image',
        props: {
            src: { type: String, required: true },
            alt: { type: String, default: '' },
            imgStyle: { type: [String, Object], default: '' },
            errorImg: { type: String },
        },
        data() {
            return {
                loaded: false,
                error: false,
                isCached: false,
            };
        },
        created() {
            // Проверяем, есть ли изображение в кэше
            const img = new Image();
            img.src = this.src;
            this.isCached = img.complete;
            if (this.isCached) {
                this.loaded = true;
            }
        },
        methods: {
            onLoad() {
                this.loaded = true;
            },
            onError(event) {
                event.target.src = this.errorImg;
                this.error = true;
                this.loaded = true;
            },
        },
    };
</script>
